import Header from './components/header';
import Footer from './containers/footer';
import RouterApp from './router/routerApp';
import React from 'react';
import './App.css';


function App() {
	return (
		<div className="App">
			<Header/>
			<RouterApp/>
			<Footer/>
		</div>
	);
}

export default App;
